/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { DataBasketsModule } from '../data-baskets.module';
export type ReuseBasketMutationVariables = Types.Exact<{
  basketId: Types.Scalars['String']['input'];
  accountId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  preserveOriginalBasket?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ReuseBasketMutation = { copy: string };

export const ReuseBasketDocument = gql`
    mutation ReuseBasket($basketId: String!, $accountId: String, $preserveOriginalBasket: Boolean) {
  copy(
    basketId: $basketId
    accountId: $accountId
    preserveOriginalBasket: $preserveOriginalBasket
  )
}
    `;

  @Injectable({
    providedIn: DataBasketsModule
  })
  export class ReuseBasketGQL extends Apollo.Mutation<ReuseBasketMutation, ReuseBasketMutationVariables> {
    document = ReuseBasketDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }